<template>
    <div :class="[boxClass(bs).box]">
        <div class="alert alert-danger" v-if="errorMessage">
          {{ errorMessage }}
        </div>
        <div :class="[boxClass(bs).boxHeader]">
            <strong><img src="https://justgiving-charitysupport.zendesk.com/hc/en-us/article_attachments/14478623773457" alt="" style="max-width: 20px;
    margin-right: 3px;">Setup your JustGiving page</strong>
            <div class="pull-right"><a :href='skipLink'>Skip</a></div>
        </div>
        <div :class="[boxClass(bs).boxBody]">
            <just-giving-authenticate
                v-if="!pageSetup && !verified"
                :participant="participant"
                @authenticated="authenticated"
                :bs="bs">
            </just-giving-authenticate>

            <just-giving-page
                v-if="!pageSetup && verified"
                :participant="participant"
                :currency="participant.registration_category.currency"
                :just_giving_charities="just_giving_charities"
                :verifiedCredentials="verifiedCredentials"
                :bs="bs">
            </just-giving-page>
        </div>
    </div>
</template>


<script>

    import JustGivingAuthenticate from "./Authenticate.vue";
    import JustGivingPage from "./Page.vue";
    import {bs} from "../../mixins/bs";

    export default {
        name: "just-giving-setup",
        props: {
            participant: {
                type: Object,
                default: () => ({}),
                required: false
            },
            just_giving_charities: {
                type: Array,
                default: () => [],
                required: true
            },
            bs: {
                type: String,
                default: () => 'bs3',
                required: false
            },
            accessToken: {
                type: String,
                default: '',
                required: true,
            },
            errorMessage: {
              type: String,
              default: () => '',
              required: true
            },
        },
        components: {
            JustGivingAuthenticate,
            JustGivingPage
        },
        mixins: [bs],
        data() {
            return {
                verifiedCredentials: {
                    accessToken: this.accessToken,
                }
            }
        },
        computed: {
            /**
             * Whether we have verified log in credentials for the user
             */
            verified: function () {
                return this.verifiedCredentials.accessToken !== '';
            },

            /**
             * Whether the user has a page setup
             */
            pageSetup: function () {
                return Boolean(this.participant.hasOwnProperty('fundraising_page') && this.participant.fundraising_page != null);
            },

            skipLink(){
                return "/users/" + this.participant.user_id + '/bookings/' + this.participant.id;
            }
        },
        methods: {
            /**
             * Called when the user has been successfully authenticated by the JustGivingAuthenticate component
             */
            authenticated(data) {
                this.verifiedCredentials.accessToken = data.accessToken;
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Assets/components/JustGivingCharities/Setup.vue